module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"error-message":"Ups! Parece que intentas acceder a una página que no existe"}}')
  delete Component.options._Ctor
}
